import { atom } from 'recoil';
const BackgroundAtom = atom({
  key: "BackgroundAtom",
  default: false,
})
const CommonTemplateAtom = atom({
  key: "CommonTemplateAtom",
  default: true,
})
export {
  BackgroundAtom,
  CommonTemplateAtom,
};